import React from 'react';

export const ErrorReportingContext = React.createContext({
    handleError: () => {},
});
